import { useParams } from "react-router";

import { PdfTemplateTabs } from "./pdf-template-tabs";

export default function PdfTemplateEditorPage() {
  const { id } = useParams();
  return <PdfTemplateTabs templateId={id!} />;
}
